// TODO: `ListingFields` doesn't actually get referenced in a query in commons
import { ListingFields } from './rql';

import { find, values, includes } from 'lodash';

export const SLEEVE_CONDITION_UUID = '09d0e8c9-e2db-4e9d-8097-62e3bdbd6534';
export const MEDIA_CONDITION_UUID = 'c9479c1a-ff31-4328-92fd-04e495e97c10';

export const MEDIA_CONDITIONS = Object.freeze({
  MINT: '2981e0e5-5770-48d8-89ab-ed4b378da220',
  NEAR_MINT: '7e6bbb82-419f-48d3-b7cd-d196cfa8ed34',
  VERY_GOOD_PLUS: '38d7284f-09bb-4d49-8dc0-6f9fb4469fea',
  VERY_GOOD: '8eec19fb-01cc-466e-b1d5-c7405f8e9538',
  GOOD_PLUS: '8945e258-e249-4c98-86d9-305f5b2098ca',
  GOOD: '06230b7a-3f8b-40a4-978b-dcdc87598fcb',
  FAIR: '896c4b33-03ea-44b4-990e-7f023d97d519',
  POOR: 'e25cdf2b-3595-4631-817f-7fc0bdac8bf4',
});

export const SLEEVE_CONDITIONS = Object.freeze({
  MINT: '6e70b061-c753-44d5-9968-e717266685da',
  NEAR_MINT: '4613cedd-0a63-4b08-a1ea-6cce4fcdc069',
  VERY_GOOD_PLUS: 'b965e14a-ece9-4287-9e27-d282af7326e4',
  VERY_GOOD: 'b0d3ffd0-81e1-4f45-a91a-a449c05bd6da',
  GOOD_PLUS: 'aac035ae-68bd-4f38-93ea-0cfaab1ffec9',
  GOOD: '1b1739f8-0d17-4692-8a8f-8e23fe2cb57c',
  FAIR: 'cf94f5a0-9b48-4f66-afc4-438ec3ed8e4e',
  POOR: '489bdbe7-9f5f-4075-859b-3da0bb9f4bf3',
  GENERIC: 'eb767f2f-cafc-4215-a823-8fe0329c0310',
  NO_COVER: '0c6a3224-bd9c-40da-a2a1-e640a0631aa4',
});

export enum ConditionType {
  Media = 'media',
  Sleeve = 'sleeve',
}

export const CONDITION_STRINGS = Object.freeze({
  NEW: 'new',
  MINT: 'mint',
  NEAR_MINT: 'nearMint',
  VERY_GOOD_PLUS: 'veryGoodPlus',
  VERY_GOOD: 'veryGood',
  GOOD_PLUS: 'goodPlus',
  GOOD: 'good',
  FAIR: 'fair',
  POOR: 'poor',
  GENERIC: 'generic',
  NO_COVER: 'noCover',
});

export const CONDITION_KEYS = Object.freeze({
  [MEDIA_CONDITIONS.MINT]: CONDITION_STRINGS.MINT,
  [MEDIA_CONDITIONS.NEAR_MINT]: CONDITION_STRINGS.NEAR_MINT,
  [MEDIA_CONDITIONS.VERY_GOOD_PLUS]: CONDITION_STRINGS.VERY_GOOD_PLUS,
  [MEDIA_CONDITIONS.VERY_GOOD]: CONDITION_STRINGS.VERY_GOOD,
  [MEDIA_CONDITIONS.GOOD_PLUS]: CONDITION_STRINGS.GOOD_PLUS,
  [MEDIA_CONDITIONS.GOOD]: CONDITION_STRINGS.GOOD,
  [MEDIA_CONDITIONS.FAIR]: CONDITION_STRINGS.FAIR,
  [MEDIA_CONDITIONS.POOR]: CONDITION_STRINGS.POOR,
  [SLEEVE_CONDITIONS.MINT]: CONDITION_STRINGS.MINT,
  [SLEEVE_CONDITIONS.NEAR_MINT]: CONDITION_STRINGS.NEAR_MINT,
  [SLEEVE_CONDITIONS.VERY_GOOD_PLUS]: CONDITION_STRINGS.VERY_GOOD_PLUS,
  [SLEEVE_CONDITIONS.VERY_GOOD]: CONDITION_STRINGS.VERY_GOOD,
  [SLEEVE_CONDITIONS.GOOD_PLUS]: CONDITION_STRINGS.GOOD_PLUS,
  [SLEEVE_CONDITIONS.GOOD]: CONDITION_STRINGS.GOOD,
  [SLEEVE_CONDITIONS.FAIR]: CONDITION_STRINGS.FAIR,
  [SLEEVE_CONDITIONS.POOR]: CONDITION_STRINGS.POOR,
  [SLEEVE_CONDITIONS.GENERIC]: CONDITION_STRINGS.GENERIC,
  [SLEEVE_CONDITIONS.NO_COVER]: CONDITION_STRINGS.NO_COVER,
});

export function getConditionKey(conditionID) {
  return CONDITION_KEYS[conditionID];
}

export const MEDIA_CONDITION_UUIDS = Object.freeze(values(MEDIA_CONDITIONS));
export const SLEEVE_CONDITION_UUIDS = Object.freeze(values(SLEEVE_CONDITIONS));

const conditionIterator = id => trait => trait.keyId === id;
const mediaConditionIterator = conditionIterator(MEDIA_CONDITION_UUID);
const sleeveConditionIterator = conditionIterator(SLEEVE_CONDITION_UUID);

export function getMediaConditionUuid(traits: ListingFields.Traits[]): string {
  const trait = find(traits, mediaConditionIterator);
  return (trait && trait.valueId) || '';
}

export function getSleeveConditionUuid(traits: ListingFields.Traits[]): string {
  const trait = find(traits, sleeveConditionIterator);
  return (trait && trait.valueId) || '';
}

interface IIsEligibleForInventorySignature {
  mediaCondition: string;
  sleeveCondition: string;
}
export function isEligibleForInventory({ mediaCondition, sleeveCondition }: IIsEligibleForInventorySignature): boolean {
  if (mediaCondition !== MEDIA_CONDITIONS.MINT) return false;
  return includes([SLEEVE_CONDITIONS.MINT, SLEEVE_CONDITIONS.NEAR_MINT], sleeveCondition);
}

const BRAND_NEW_CONDITION_UUIDS = Object.freeze([
  '6db7df88-293b-4017-a1c1-cdb5e599fa1a', // mint-inventory,
  '9225283f-60c2-4413-ad18-1f5eba7a856f', // b-stock,
  '7c3f45de-2ae0-4c81-8400-fdb6b1d74890', // brand-new
]);

export function isCoreBrandNew(conditionUuid) {
  return BRAND_NEW_CONDITION_UUIDS.indexOf(conditionUuid) > -1;
}



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/src/condition_helpers.ts